<form class="register-form" #form="ngForm" (ngSubmit)="submit()" novalidate>

  <!-- ─── Header ───────────────────────────────────────────────────────────── -->
  <div class="modal-header">
    <h5 class="modal-title fw-bold">{{ title | slice:0:1 | uppercase }}{{ title | slice:1 }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body p-3">

    <!-- ─── Contexte hébergement ───────────────────────────────────────────── -->
    <div class="alert alert-info py-2 px-3 mb-3 d-flex gap-3 align-items-center" style="font-size:13px;">
      <i class="fa fa-bed me-1"></i>
      <span><strong>Client :</strong> {{ itemToSave.client_nom }} / {{ itemToSave.client_telephone }}</span>
      <span class="ms-3"><strong>Chambre :</strong> {{ itemToSave.chambre_libelle }}</span>
    </div>

    <!-- ─── Sélection programme ────────────────────────────────────────────── -->
    <div class="row g-2 mb-3">
      <div class="col-md-4">
        <label class="form-label small fw-bold mb-1">Programme de menus</label>
        <ng-select name="programme_menu_id" (change)="onSelectMenuProgramme()" [items]="itemsMenuProgramme"
          bindLabel="libelle" bindValue="id" placeholder="-- Sélectionner un programme --"
          [(ngModel)]="programme_menu_id" [searchable]="true" [clearable]="true">
        </ng-select>
      </div>
    </div>

    <!-- ─── Contenu principal : Grille gauche | Panier droite ──────────────── -->
    <div class="row g-3">

      <!-- ── Gauche : menus à choisir ─────────────────────────────────────── -->
      <div class="col-md-7">

        <!-- Recherche menu -->
        <div class="input-group mb-2">
          <input type="text" class="form-control" [(ngModel)]="menu_search" name="menu_search"
            placeholder="Rechercher un menu..." autocomplete="off"
            style="height: 40px; font-size: 14px; border: 1px solid #ced4da; width:100%" />
          <button type="button" class="btn btn-outline-secondary" *ngIf="menu_search" (click)="menu_search = ''">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Message si pas de programme sélectionné -->
        <div *ngIf="!programme_menu_id" class="text-center text-muted py-5 border rounded">
          <i class="fa fa-utensils fa-2x d-block mb-2 opacity-25"></i>
          <small>Sélectionnez un programme pour voir les menus disponibles</small>
        </div>

        <!-- Grille menus -->
        <div *ngIf="programme_menu_id" style="max-height: 380px; overflow-y: auto; overflow-x: hidden;">
          <div class="row g-2">
            <div class="col-xl-3 col-md-4 col-sm-6 col-6" *ngFor="let menu of filteredMenus">
              <div class="card h-100 position-relative" [class.border-primary]="isInCart(menu)"
                style="transition: box-shadow .15s;">
                <span *ngIf="isInCart(menu)" class="badge bg-primary position-absolute top-0 end-0 m-1"
                  style="z-index:1; font-size:10px;">
                  × {{ getCartQty(menu) }}
                </span>
                <img [src]="menu.image_url || 'assets/images/default/default.avif'" class="card-img-top"
                  style="height: 80px; object-fit: cover;" alt="" />
                <div class="card-body p-1">
                  <div class="fw-bold text-truncate" style="font-size:11px;" [title]="menu.menu_libelle">
                    {{ menu.menu_libelle }}
                  </div>
                  <div class="text-primary fw-bold" style="font-size:12px;">
                    {{ menu.prix | IntegerFormatPipe }}
                  </div>
                </div>
                <div class="card-footer p-1">
                  <button type="button" class="btn btn-sm btn-primary w-100" style="font-size:11px; padding:2px 0;"
                    (click)="addToCart(menu)">
                    <i class="fa fa-cart-plus"></i> Ajouter
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="programme_menu_id && !filteredMenus.length" class="col-12 text-center text-muted py-4">
              <i class="fa fa-box-open fa-2x d-block mb-2"></i>
              Aucun menu trouvé
            </div>
          </div>
        </div>
      </div>

      <!-- ── Droite : menus choisis + résumé ─────────────────────────────── -->
      <div class="col-md-5 d-flex flex-column" style="max-height: 460px;">

        <!-- Liste panier -->
        <div style="flex:1; overflow-y: auto; min-height: 0;">

          <!-- En-tête -->
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="fw-bold" style="font-size:13px;">
              <i class="fa fa-shopping-cart me-1 text-primary"></i>
              Panier
              <span class="badge bg-primary ms-1" *ngIf="itemsCommandeDetailToSave.length">
                {{ itemsCommandeDetailToSave.length }}
              </span>
            </span>
          </div>

          <!-- Items -->
          <div *ngFor="let item of itemsCommandeDetailToSave; let j = index"
            class="d-flex align-items-center gap-2 p-2 mb-2 border rounded bg-white"
            style="box-shadow: 0 1px 3px rgba(0,0,0,.06);">

            <img [src]="item.menu_image_url || 'assets/images/default/default.avif'"
              style="width:50px; height:50px; object-fit:cover; border-radius:6px; flex-shrink:0;" alt="" />

            <div style="flex:1; min-width:0;">
              <div class="fw-bold text-truncate" style="font-size:12px;">{{ item.menu_libelle }}</div>
              <div class="text-muted text-truncate" style="font-size:10px;">{{ item.menu_description }}</div>
              <div class="text-primary fw-bold" style="font-size:11px;">{{ item.total | IntegerFormatPipe }}</div>
            </div>

            <!-- Quantité −/+ -->
            <div class="d-flex align-items-center border rounded" style="flex-shrink:0;">
              <button type="button" class="btn btn-link btn-sm px-2 py-0 text-dark text-decoration-none"
                style="font-size:16px; line-height:1.4;" (click)="decrementCartQty(item, j)">−</button>
              <input type="number" class="border-0 text-center fw-bold"
                style="width:32px; font-size:12px; outline:none;" [(ngModel)]="item.quantite" [name]="'qty_' + j"
                (change)="onCartQtyChange(item)" min="1" />
              <button type="button" class="btn btn-link btn-sm px-2 py-0 text-dark text-decoration-none"
                style="font-size:16px; line-height:1.4;" (click)="incrementCartQty(item)">+</button>
            </div>

            <!-- Supprimer -->
            <button type="button" class="btn btn-sm text-muted p-0"
              style="font-size:18px; line-height:1; background:none; border:none; flex-shrink:0;"
              (click)="itemsCommandeDetailToSave.splice(j, 1)" title="Retirer">×</button>
          </div>

          <!-- Panier vide -->
          <div *ngIf="!itemsCommandeDetailToSave.length" class="text-center text-muted py-5 border rounded">
            <i class="fa fa-shopping-cart fa-2x d-block mb-2 opacity-25"></i>
            <small>Ajoutez des menus depuis la grille</small>
          </div>
        </div>

        <!-- Résumé fixe en bas -->
        <div class="border rounded p-3 mt-2 bg-white" style="flex-shrink:0; box-shadow:0 1px 4px rgba(0,0,0,.06);">
          <div class="d-flex justify-content-between mb-1" style="font-size:13px;">
            <span class="text-muted">Menus</span>
            <span class="fw-bold">{{ itemsCommandeDetailToSave.length }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2" style="font-size:13px;">
            <span class="text-muted">Sous-total</span>
            <span class="fw-bold">{{ cartTotal | IntegerFormatPipe }}</span>
          </div>
          <hr class="my-2" />
          <div class="d-flex justify-content-between mb-3" style="font-size:15px;">
            <span class="fw-bold">Total</span>
            <span class="fw-bold text-primary">{{ cartTotal | IntegerFormatPipe }}</span>
          </div>
          <button type="button" class="btn btn-primary w-100"
            [disabled]="isLoading || !itemsCommandeDetailToSave.length" (click)="confirmSaveItem(itemToSave)">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isLoading" class="fa fa-check me-1"></i>
            Enregistrer la commande
          </button>
        </div>

      </div>
    </div>

  </div><!-- end modal-body -->

  <div class="modal-footer py-2">
    <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.dismiss()">Fermer</button>
  </div>

</form>